import Vue from 'vue'
import Vuex from 'vuex'
import { Bus } from '@/components/Bus'
import chartData from '@/data/data.json'
import raw from '@/data/raw-data.csv'
import router from '@/router'

Vue.use(Vuex)

const defaultFilters = {
  age: 'Show All',
  region: 'Show All',
  sex: 'Show All',
  income: 'Show All',
  industry: 'Show All'
}

const rawAgeData = raw.map(elm => {
  return {
    age: elm[2],
    region: elm[1],
    sex: elm[0],
    income: elm[14],
    industry: elm[15],
    events: {
      'buying-a-car': Number(elm[3]),
      'buying-a-home': Number(elm[4]),
      'leaving-education': Number(elm[5]),
      'getting-a-job': Number(elm[6]),
      'reaching-the-height-of-my-career': Number(elm[7]),
      'getting-engaged': Number(elm[8]),
      'getting-married': Number(elm[9]),
      'having-a-child': Number(elm[10]),
      'retiring': Number(elm[11]),
      'having-a-grandchild': Number(elm[12]),
      'planning-my-funeral': Number(elm[13])
    }
  }
})

const averageAgeRanges = (data) => {
  const averages = {
    'leaving-education': 0,
    'getting-a-job': 0,
    'buying-a-car': 0,
    'getting-engaged': 0,
    'having-a-child': 0,
    'buying-a-home': 0,
    'getting-married': 0,
    'reaching-the-height-of-my-career': 0,
    'planning-my-funeral': 0,
    'having-a-grandchild': 0,
    'retiring': 0
  }

  Object.keys(averages).forEach(key => {
    let length = 0

    data.forEach(dataset => {
      const value = dataset.events[key]
      if (value !== 'Never') {
        averages[key] += dataset.events[key]
        length += 1
      } else {
        console.log('nope')
      }
    })
    averages[key] = Math.floor(averages[key] / length)
  })

  var result = Object.keys(averages).map(function (key) {
    return {
      'event': key,
      'age': averages[key]
    }
  })

  return result
}

export default new Vuex.Store({
  strict: true,
  state: {
    chartData,
    rawAgeData: JSON.parse(JSON.stringify(rawAgeData)),
    defaultFilters,
    filteredAgeData: averageAgeRanges(rawAgeData),
    filters: JSON.parse(JSON.stringify(defaultFilters)),
    modalDataName: '',
    feelings: chartData.charts.feelings['buying-a-car'],
    attitude: chartData.charts.attitude['buying-a-car'],
    cost: chartData.charts.cost['buying-a-home'].values,
    checkShowAll: true,
    costTitle: chartData.charts.cost['buying-a-home'].title
  },
  mutations: {
    setFilter (state, payload) {
      state.filters = Object.assign(state.filters, payload)
    },
    resetFilters (state) {
      state.filters = Object.assign({}, state.defaultFilters)
      state.filteredAgeData = averageAgeRanges(rawAgeData)
      router.replace('/timeline')
    },
    setModalDataName (state, payload) {
      state.modalDataName = payload.name
      state.feelings = payload.feelings
      state.attitude = payload.attitude
      state.cost = payload.cost
      state.costTitle = payload.costTitle
    },
    setFilteredAgeData (state, payload) {
      state.filteredAgeData = payload.filteredAgeData
    }
  },
  getters: {
    getFilters: state => state.filters,
    getChartData: state => state.chartData,
    getModalDataName: state => state.modalDataName,
    getRawData: state => state.rawData,
    getFilteredAgeData: state => state.filteredAgeData,
    getActiveFeelings: state => state.feelings,
    getActiveAttitude: state => state.attitude,
    getActiveCost: state => state.cost,
    getActiveCostTitle: state => state.costTitle
  },
  actions: {
    applyFilters (context) {
      return new Promise((resolve, reject) => {
        let filteredAgeData = context.state.rawAgeData.slice(0)

        const filters = context.state.filters

        Object.keys(filters).forEach(key => {
          if (filters[key] !== 'Show All') {
            filteredAgeData = filteredAgeData.filter(elm => {
              return String(elm[key]) === String(filters[key])
            })
          }
        })

        if (filteredAgeData.length === 0) {
          Bus.$emit('noResults')
          reject(new Error('no results'))
        } else {
          filteredAgeData = averageAgeRanges(filteredAgeData)

          this.commit('setFilteredAgeData', {
            filteredAgeData
          })
          resolve()
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js